import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import http from './../../../services/Api'

import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { RiLoader4Line } from 'react-icons/ri'

import './index.css'

export default function ChartConfig({ device, location, group, onSaveModalForm, travel }) {
  const { register, handleSubmit, setValue } = useForm();
  const [locations, setLocations] = useState([])
  const [deviceLocation, setDeviceLocation] = useState('')
  const [ambients, setAmbients] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setValue('name', device.name)
    setValue('config[temperature][max]', device.config?.temperature?.max)
    setValue('config[temperature][min]', device.config?.temperature?.min)

    setValue('config[humidity][max]', device.config?.humidity?.max)
    setValue('config[humidity][min]', device.config?.humidity?.min)
    if (location) {
      init();
      setDeviceLocation(location.id)
    }
  }, [device]) // eslint-disable-line react-hooks/exhaustive-deps

  const init = async () => {
    setLoading(true)
    await getLocations();
    await getAmbients(location._id);
    setLoading(false)
    setValue('location_id', location._id)
    setValue('group_id', group.id)
  }

  const getLocations = async () => {
    try {
      let response = await http.get('/api/locations');
      setLocations(response.data);
    } catch (e) {
      console.log(e)
    }
  }

  const getAmbients = async (locationId) => {
    try {
      let response = await http.get('/api/devices-groups/by-location/' + locationId);
      setAmbients(response.data);
      return response.data;
    } catch (e) {
      console.log(e)
    }
  }

  const changeLocation = async ({ target }) => {
    let locationId = target.value;
    const data = await getAmbients(locationId)
    setValue('group_id', data[0]._id)
  }

  const save = async data => {
    try {
      setLoading(true)
      let response = await http.put(`/api/devices/${device._id}`, data)
      setLoading(false);
      onSaveModalForm(response)
    } catch (e) {
      console.log(e)
    }
  }

  const saveTravelDevice = async data => {
    data.travel_id = travel._id
    data.device_id = device._id
    try {
      setLoading(true)
      let response = await http.put(`/api/travels/edit-travel-device`, data)
      setLoading(false);
      onSaveModalForm(travel)
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <div className="ConfigDevice">
      <Form method="POST" onSubmit={location ? handleSubmit(save) : handleSubmit(saveTravelDevice)}>
        <h3>Configurações básicas</h3>
        <Form.Group>
          <Form.Label>Nome</Form.Label>
          <Form.Control type="text" name="name" ref={register} />
        </Form.Group>

        {location &&
          <>
            <Form.Group>
              <Form.Label>Local</Form.Label>
              {loading
                ?
                <Form.Control type="text" disabled placeholder="Carregando..." />
                :
                <Form.Control name="location_id" as="select" onChange={changeLocation} ref={register} defaultValue={deviceLocation}>
                  {locations.map((location) => (
                    <option value={location._id}>{location.name}</option>
                  ))}
                </Form.Control>
              }
            </Form.Group>

            <Form.Group>
              <Form.Label>Ambiente</Form.Label>
              {loading
                ?
                <Form.Control type="text" disabled placeholder="Carregando..." />
                :
                <Form.Control name="group_id" as="select" ref={register}>
                  {ambients.map((ambient) => (
                    <option value={ambient._id}>{ambient.name}</option>
                  ))}
                </Form.Control>
              }
            </Form.Group>
          </>
        }

        <h3>Configuracões para alertas</h3>

        <Row>
          <Col md={6}>
            <Form.Label>Temperatura Máxima</Form.Label>
          </Col>

          <Col md={6}>
            <Form.Label>Temperatura Minima</Form.Label>
            <Form.Control type="number" name="config[temperature][min]" ref={register} />
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Form.Label>Humidade Máxima</Form.Label>
            <Form.Control type="number" name="config[humidity][max]" ref={register} />
          </Col>

          <Col md={6}>
            <Form.Label>Humidade Minima</Form.Label>
            <Form.Control type="number" name="config[humidity][min]" ref={register} />
          </Col>
        </Row>

        <Button variant="primary" type="submit">
          {loading ? (<RiLoader4Line className="spin" />) : 'Salvar'}
        </Button>
      </Form>
    </div>
  )
}